import { memo } from 'react';
import { clsx } from 'clsx';

interface BadgeProps {
  label: string;
  variant?: 'yellow' | 'black' | 'white' | 'success' | 'warning' | 'error' | 'info';
  size?: 'sm' | 'md';
}

const variantClasses = {
  yellow: 'bg-brand-yellow text-brand-black',
  black: 'bg-brand-black text-brand-white',
  white: 'bg-white text-brand-black border border-gray-200',
  success: 'bg-green-100 text-green-800',
  warning: 'bg-yellow-100 text-yellow-800',
  error: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800',
};

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
};

function BadgeInner({ label, variant = 'yellow', size = 'sm' }: BadgeProps) {
  return (
    <span className={clsx('inline-flex items-center font-medium rounded-full', variantClasses[variant], sizeClasses[size])}>
      {label}
    </span>
  );
}

export const Badge = memo(BadgeInner);
Badge.displayName = 'Badge';
